import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon, { NAMES } from '@ifit/react-icons';
import { scienceBlue } from '../../theme/colors';

import './index.css';

class ProductButton extends Component {
  render() {
    const { onClick, image, alt, text } = this.props;

    return (
      <div className="product-button">
        <button onClick={ onClick }>
          <div className="logo">
            <img src={ image } alt={ alt } />
            <span className="copy">{ text }</span>
          </div>
          <div className="arrow">
            <Icon name={ NAMES.ARROW_RIGHT_LONG } color={ scienceBlue } size={ 24 } />
          </div>
        </button>
      </div>
    );
  }
}

ProductButton.propTypes = {
  onClick: PropTypes.func,
  image: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

export default ProductButton;
